/**
 * Select Selling Plan Action
 * Triggered by: arc:action:selectSellingPlan
 */

// Initialize cart integration once when module loads
let cartIntegrationInitialized = false;

export const runSelectSellingPlan = async (data = {}) => {
    try {
        // Initialize cart integration if not already done
        if (!cartIntegrationInitialized) {
            initializeSellingPlanCartIntegration();
            cartIntegrationInitialized = true;
        }

        const { 
            sellingPlanElement, 
            sellingPlanId, 
            sellingPlanPrice,
            autoUpdate = true 
        } = data;

        if (!sellingPlanElement && !sellingPlanId) {
            throw new Error('Either sellingPlanElement or sellingPlanId is required');
        }

        let targetElement = sellingPlanElement;
        
        // If only sellingPlanId is provided, find the element
        if (!targetElement && sellingPlanId) {
            targetElement = document.querySelector(`input[value="${sellingPlanId}"]`);
            if (!targetElement) {
                throw new Error(`Selling plan element not found for ID: ${sellingPlanId}`);
            }
        }

        // Store the selected selling plan globally for cart operations
        window.selectedSellingPlan = targetElement.value;

        if (autoUpdate) {
            await updateSellingPlanPricing(targetElement);
        }

        // Dispatch selling plan selected event
        window.dispatchEvent(new CustomEvent("sellingPlanSelected", {
            detail: {
                sellingPlan: targetElement,
                sellingPlanId: targetElement.value,
                sellingPlanPrice: targetElement.getAttribute("data-sellinggroup-price"),
                element: targetElement
            }
        }));

        return {
            success: true,
            sellingPlanId: targetElement.value,
            sellingPlanElement: targetElement,
            message: 'Selling plan selected successfully'
        };

    } catch (error) {
        console.error('Select Selling Plan error:', error);
        
        window.dispatchEvent(new CustomEvent('sellingPlan:error', {
            detail: {
                error: error.message,
                action: 'selectSellingPlan'
            }
        }));

        return {
            success: false,
            error: error.message
        };
    }
};

// Helper function to update selling plan pricing
const updateSellingPlanPricing = async (sellingPlanElement) => {
    const variantPrice = sellingPlanElement.getAttribute("data-sellinggroup-price");
    const quantityInputEl = document.getElementById('quantityInput');
    const qty = quantityInputEl?.querySelector('input')?.value || 1;
    
    // Get the closest product form to update the correct add button
    const sellingGroupParent = sellingPlanElement.closest('.product-selling-groups');
    const productFormEl = sellingGroupParent?.querySelector('.product-form');

    // Get current variant availability
    const currentVariant = window.currentVariant;
    let variantAvailability = "true"; // default to available
    
    if (currentVariant) {
        const variantElement = document.querySelector(`input[data-variant-id="${currentVariant}"]`);
        variantAvailability = variantElement?.getAttribute("data-variant-available") || "true";
    }

    // Get currency symbol
    const currencySymbol = window.Alpine?.store('currency')?.getCurrencySymbol() || '$';
    const parsedPrice = parseFloat(variantPrice.replace("$", ""));
    let displayPrice = `${currencySymbol}${(parsedPrice * qty).toFixed(2)}`;

    if (variantAvailability !== "false") {
        // Dispatch event to update add button with new pricing
        window.dispatchEvent(new CustomEvent('addButton:update', {
            detail: {
                disabled: false,
                text: `Add to Cart | ${displayPrice}`,
                modifyClass: true,
                price: parsedPrice,
                targetForm: productFormEl
            }
        }));
    }
};

// Initialize selling plan cart integration
export const initializeSellingPlanCartIntegration = () => {
    // Listen for liquid-ajax-cart requests to inject selling plan
    document.addEventListener("liquid-ajax-cart:request-start", function (event) {
        const { requestState } = event.detail;

        if (requestState.requestType === "add") {
            // Find the selected selling plan from the radio buttons
            let selectedSellingPlan = document.querySelector(
                ".pdp-details .product-selling-groups input[type=radio]:checked"
            );

            if (!selectedSellingPlan) {
                selectedSellingPlan = document.querySelector(
                    ".product-tile-hovered input[type=radio]:checked"
                );
            }

            if (selectedSellingPlan) {
                const selectedSellingPlanId = selectedSellingPlan.value;

                if (selectedSellingPlan.value !== "on") {
                    if (requestState.requestBody instanceof FormData || 
                        requestState.requestBody instanceof URLSearchParams) {
                        requestState.requestBody.set("selling_plan", selectedSellingPlanId);
                    } else {
                        requestState.requestBody.selling_plan = selectedSellingPlanId;
                    }
                }
            }
        }
    });
};

export default runSelectSellingPlan;
